//export const BaseUrl = 'http://localhost:8000/api/v2';
//export const media = "http://localhost:8000/";
//export const BlogUrl="http://localhost:3000/BlogeDetails/"
export const BaseUrl = 'https://api.alnomanlaw.com/api/v2';
export const media = "https://api.alnomanlaw.com/";
export const BlogUrl="https://alnomanlaw.com/BlogeDetails/"